import { TOUR_HELP_TARGET } from "./constants";
import type { TourDefinition } from "./types";

type TourSectionEntry = {
  section: string;
  fromCanonical: number;
  stepCount: number;
};

export const getCanonicalStep = (definition: TourDefinition, id: string) =>
  definition.steps.findIndex((step) => step.id === id) + 1;

export const getStepTarget = (definition: TourDefinition, id: string | undefined) =>
  definition.steps.find((step) => step.id === id)?.target ?? TOUR_HELP_TARGET;

export function getTourSections(definition: TourDefinition, stepIds: string[]): TourSectionEntry[] {
  return definition.sections.flatMap((section) => {
    const sectionStepIds = definition.steps
      .filter((step) => step.section === section && stepIds.includes(step.id))
      .map((step) => step.id);
    const [firstStepId] = sectionStepIds;
    if (!firstStepId) return [];
    return [{ section, fromCanonical: getCanonicalStep(definition, firstStepId), stepCount: sectionStepIds.length }];
  });
}

export function getResumeIndex(definition: TourDefinition, stepIds: string[], resumeStep: number): number {
  const index = stepIds.findIndex((id) => getCanonicalStep(definition, id) >= resumeStep);
  return index === -1 ? 0 : index;
}
